
const open_button = document.getElementsByClassName("open_filters");
const target = document.getElementsByClassName("container-wrapper");
const close_button = document.getElementsByClassName("close_filters");

open_button[0].addEventListener('click', (e) => {
  e.preventDefault();
  target[0].classList.add('show')
});

close_button[0].addEventListener('click', (e) => {
  e.preventDefault();
  target[0].classList.remove('show')
});